import type { Style, Transform, VectorFn } from "~/lib/types";
import type { NodeDefinition } from "~/nodes/types";

export const outputNode: NodeDefinition = {
  type: "output",
  label: "Output",
  category: "Output",
  inputs: [
    { key: "v3", label: "Vector", socket: "vector" },
    { key: "style", label: "Style", socket: "style" },
    { key: "transform", label: "Transform", socket: "transform" },
    {
      key: "delta",
      label: "Delta",
      socket: "number",
      control: { kind: "number", key: "delta", label: "delta", step: 0.001 },
    },
    {
      key: "nops",
      label: "Point Number",
      socket: "number",
      control: { kind: "number", key: "nops", label: "points", step: 50 },
    },
    {
      key: "initial",
      label: "Initial",
      socket: "number",
      control: { kind: "number", key: "initial", label: "initial", step: 0.1 },
    },
  ],
  outputs: [],
  controls: [],
  defaults: { delta: 0.005, nops: 2000, initial: 0 },

  compute(ctx) {
    ctx.emit({
      vector: ctx.connected<VectorFn>("v3"),
      style: ctx.connected<Style>("style"),
      transform: ctx.connected<Transform>("transform"),
      delta: ctx.number("delta", 0.005),
      nops: ctx.number("nops", 2000),
      initial: ctx.number("initial", 0),
    });
  },
};
